import { AuthFBResetPassword } from "./reset-password-firebase-link";
import { Header } from "../../common/header";
import { Footer } from "../main-page/footer";
import { useAuthContext } from "../../../contexts/auth-context";
import { AuthFireBaseVerifyEmail } from "./verify-email-firebase-link";

export const AuthFirebaseActions = () => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");
    const { isLoggedIn, logOutUser } = useAuthContext();

    if (isLoggedIn && mode === "resetPassword") {
        logOutUser();
    }

    switch (mode) {
        case "resetPassword":
            return <AuthFBResetPassword />;

        case "verifyEmail":
            return <AuthFireBaseVerifyEmail />;

        default:
            return (
                <>
                    <Header title="" />
                    <div className="container py-5 text-center">
                        <i className="fa-solid fa-circle-exclamation text-primary fs-2 mb-2"></i>
                        <p className="fw-bold text-primary">This link is invalid or has expired.</p>
                    </div>
                    <Footer />
                </>
            );
    }
};
